module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-infiniti.666a86fd.png";